"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _draftExtend = require("draft-extend");

var _draftJs = require("draft-js");

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _FileManagerApi = require("../api/FileManagerApi");

var _changeBlockData = _interopRequireDefault(require("../utils/changeBlockData"));

var _createImageMetadata = _interopRequireDefault(require("../utils/createImageMetadata"));

var _domUtils = require("../utils/domUtils");

var _insertAtomicBlockWithData = _interopRequireDefault(require("../utils/insertAtomicBlockWithData"));

var isImageFile = function isImageFile(file) {
  return /image\//.test(file.type);
};

var getImageDimensions = function getImageDimensions(blob) {
  var image = new Image();
  image.src = blob;
  return new Promise(function (resolve) {
    image.onload = function () {
      resolve({
        width: this.width,
        height: this.height
      });
    };
  });
};

var _default = function _default() {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  return function (WrappingComponent) {
    if (plugins.length === 0) {
      return WrappingComponent;
    }

    var pluginComposition = _draftExtend.compose.apply(void 0, plugins);

    var WrappedComponentWithPlugins = pluginComposition(WrappingComponent);

    if (WrappingComponent.prototype && WrappingComponent.prototype.isReactComponent) {
      return _react.default.createClass({
        propTypes: {
          editorState: _react.PropTypes.instanceOf(_draftJs.EditorState).isRequired,
          onChange: _react.PropTypes.func.isRequired,
          handlePastedFiles: _react.PropTypes.func
        },
        childContextTypes: {
          blur: _react.PropTypes.func,
          focus: _react.PropTypes.func
        },
        getInitialState: function getInitialState() {
          return {
            file: null
          };
        },
        getChildContext: function getChildContext() {
          return {
            blur: this.blur,
            focus: this.focus
          };
        },
        componentWillMount: function componentWillMount() {
          var _this = this;

          this.fileReader = new FileReader();
          this.fileReader.addEventListener('load', function () {
            var _this$props = _this.props,
                editorState = _this$props.editorState,
                onChange = _this$props.onChange;
            var tempFileUrl = _this.fileReader.result;
            getImageDimensions(tempFileUrl).then(function (_ref) {
              var width = _ref.width,
                  height = _ref.height;
              var rawData = {
                isTemporary: true,
                src: tempFileUrl,
                uploadPercent: 10 // show a little bit of progress to start

              };

              if (_this._child) {
                var editorNode = (0, _reactDom.findDOMNode)(_this._child).querySelector('.DraftEditor-root');
                var editorWidth = (0, _domUtils.getUnpaddedElementWidth)(editorNode);

                if (width > editorWidth) {
                  var originalRatio = width / height;
                  rawData.originalDimensions = {
                    width: width,
                    height: height
                  };
                  rawData.width = editorWidth;
                  rawData.height = Math.round(editorWidth / originalRatio);
                }
              }

              var data = (0, _createImageMetadata.default)(rawData);
              onChange((0, _insertAtomicBlockWithData.default)(editorState, data));

              _this.uploadPastedFile(tempFileUrl);
            });
          }, false);
        },
        blur: function blur() {
          if (this._child.blur) {
            this._child.blur();
          }
        },
        focus: function focus() {
          if (this._child.focus) {
            this._child.focus();
          }
        },
        getUploadProgressHandler: function getUploadProgressHandler(blockToUpdate) {
          var _this$props2 = this.props,
              editorState = _this$props2.editorState,
              onChange = _this$props2.onChange;
          return function (progress) {
            if (!progress.lengthComputable) {
              return;
            }

            var percentComplete = parseInt(progress.loaded / progress.total, 10) * 100;
            var updatedBlockData = blockToUpdate.getData().mergeDeep({
              image: {
                uploadPercent: percentComplete
              }
            });
            onChange((0, _changeBlockData.default)({
              editorState: editorState,
              block: blockToUpdate,
              updatedBlockData: updatedBlockData,
              preserveSelection: true
            }));
          };
        },
        uploadPastedFile: function uploadPastedFile(dataUrl) {
          var _this2 = this;

          var _this$props3 = this.props,
              editorState = _this$props3.editorState,
              onChange = _this$props3.onChange;
          var file = this.state.file;

          if (!file) {
            return;
          }

          var blockToUpdate = editorState.getCurrentContent().getBlockMap().find(function (block) {
            return block.getData().getIn(['image', 'src']) === dataUrl;
          });
          (0, _FileManagerApi.uploadFile)(file, {
            onProgress: this.getUploadProgressHandler(blockToUpdate)
          }).then(function (data) {
            var fileUrl = data.objects[0].url;
            var updatedBlockData = blockToUpdate.getData().mergeDeep({
              image: {
                isTemporary: false,
                uploadPercent: 100,
                src: fileUrl
              }
            });
            onChange((0, _changeBlockData.default)({
              editorState: _this2.props.editorState,
              block: blockToUpdate,
              updatedBlockData: updatedBlockData,
              preserveSelection: true
            }));
          });
        },
        handlePastedFiles: function handlePastedFiles(files) {
          var handlePastedFiles = this.props.handlePastedFiles;

          if (!files || files.length === 0) {
            return false;
          }

          var file = files[0];

          if (!isImageFile(file)) {
            return false;
          }

          this.setState({
            file: file
          });
          this.fileReader.readAsDataURL(file);

          if (handlePastedFiles) {
            return handlePastedFiles(files);
          }

          return true;
        },
        render: function render() {
          var _this3 = this;

          return _react.default.createElement(WrappedComponentWithPlugins, (0, _extends2.default)({}, this.props, {
            ref: function ref(c) {
              return _this3._child = c;
            },
            handlePastedFiles: this.handlePastedFiles
          }));
        }
      });
    }

    return WrappedComponentWithPlugins;
  };
};

exports.default = _default;
module.exports = exports.default;